<template lang="pug">
.form-order.center
  .section-title(@click="show.data = !show.data")
    h3.capitalize
      span Datos

  transition(name="slide-fade")
    .section-container(v-if="show.data")
      form(@submit.prevent="" autocomplete="off")
        .form-section
          .input-container(v-if="dataForm.isDropshipping")
            input.input(v-model="dataForm.isDropshipping" autocomplete="ño" :disabled="true" required)
            label.label.disabled(:class="{ show: dataForm.isDropshipping }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="isDropshipping" title="Es Dropshipping")

        .form-section
          .input-container
            input.input(v-model="dataForm.dni" type="number" autocomplete="ño")
            label.label(:class="{ show: dataForm.dni }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="dni" title="Documento")
          .input-container
            input.input(v-model="dataForm.name" autocomplete="ño" :disabled="buyerDataLocked" required)
            label.label(:class="{ show: dataForm.name, disabled: buyerDataLocked }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="name" title="Nombre")
            shOrderDataHistory(v-if="fillData" :entries="nameHistory")

        .form-section
          shInputList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="teléfono" property="phones" pattern="[0-9]{10}" :required="1" :disabled="buyerDataLocked")
          shOrderDataHistory(v-if="fillData" :entries="phoneHistory" format="phone")

        .form-section
          .input-container
            input.input(v-model="dataForm.email" type="email" autocomplete="ño" required)
            label.label(:class="{ show: dataForm.email }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="email" title="email")
            shOrderDataHistory(v-if="fillData" :entries="emailHistory")

          .input-container(v-if="!dataForm.location")
            input.input(
              ref="locationInput"
              v-model="search"
              autocomplete="off"
              pattern="^sahetjeans$"
              title="Elige una ubicación de la lista"
              :disabled="buyerDataLocked"
              :required="!dataForm.location"
              @input="onLocationSearch"
              @compositionupdate="onLocationSearch"
              @keydown.prevent.up="moveLocationUp"
              @keydown.prevent.down="moveLocationDown"
              @keydown.prevent.enter="chooseLocation()"
            )
            label.label(:class="{ show: dataForm.location || search, disabled: buyerDataLocked, 'property-modified': isLocationPairModified }")
              span Ubicación
              span.location-label-original(v-if="isLocationPairModified")  ({{ originalLocationPair }})
            shOrderDataHistory(v-if="fillData" :entries="locationHistory")

          .input-container.location-confirmed(
            v-if="dataForm.location"
            :class="{ 'location-locked': buyerDataLocked }"
            @click="onLocationConfirmedClick"
          )
            input.input(
              type="text"
              :value="`${dataForm.location} - ${dataForm.department}`"
              autocomplete="off"
              readonly
              :disabled="buyerDataLocked"
              required
            )
            label.label.show(:class="{ disabled: buyerDataLocked, 'property-modified': isLocationPairModified }")
              span Ubicación
              span.location-label-original(v-if="isLocationPairModified")  ({{ originalLocationPair }})
            shOrderDataHistory(v-if="fillData" :entries="locationHistory")

          .left(v-if="showLocations && !dataForm.location && search && !buyerDataLocked")
            .choose-location-text(v-if="locationsFiltered.length") ELIGE TU UBICACIÓN
            .locations
              div(
                v-for="(location, index) in locationsFiltered"
                :key="`${location.location}-${location.department}`"
                :class="{ 'location-option-selected': index === hoverLocation }"
                @mouseenter="hoverLocation = index"
              )
                shActionButton(
                  :action="chooseLocation"
                  :params="[location]"
                  :text="`${location.location} - ${location.department}`"
                  :textRunning="`${location.location} - ${location.department}`"
                  :normalColor="true"
                )

          .no-found.left(v-if="searched && !locationsFiltered.length && !dataForm.location && !buyerDataLocked") No se encontró la ubicación que buscas

          .input-container.arrow
            label.label(:class="{ show: typeof dataForm.community }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="community" title="Localidad")
            select.select.capitalize(v-model="dataForm.community" autocomplete="ño")
              option(v-for="community in communities" :value="community") {{ community }}

          .input-container
            label.label(:class="{ show: dataForm.address, disabled: buyerDataLocked }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="address" title="Dirección")
            textarea.input(v-model="dataForm.address" autocomplete="ño" rows="5" :disabled="buyerDataLocked" required)
            shOrderDataHistory(v-if="fillData" :entries="addressHistory")
          shOrderAddressMap(:lat="dataOriginal.lat" :lng="dataOriginal.lng")

        .form-section
          .input-container
            select.select(v-model="dataForm.conveyor" autocomplete="ño")
              option(v-for="conveyor in conveyors" :value="conveyor") {{ capitalize(conveyor) }}
            label.label(:class="{ show: dataForm.conveyor }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyor" title="Transportadora")
          .input-container
            input.input(v-model.number="dataForm.conveyorCost" autocomplete="ño" disabled required)
            label.label.disabled(:class="{ show: dataForm.conveyorCost >= 0 }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyorCost" title="Costo Transportadora")
          .input-container.arrow
            select.select(v-model="dataForm.userPayConveyor" autocomplete="ño" disabled)
              option(:value="true") Sí
              option(:value="false") No
            label.label.disabled(:class="{ show: typeof dataForm.userPayConveyor === 'boolean' }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="userPayConveyor" title="Envío al cobro")
          .input-container.arrow
            select.select(v-model="dataForm.isWholesaler" autocomplete="ño" disabled)
              option(:value="true") Sí
              option(:value="false") No
            label.label.disabled(:class="{ show: typeof dataForm.isWholesaler === 'boolean' }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="isWholesaler" title="Es Mayorista")
          .input-container.arrow
            select.select.capitalize(v-model="dataForm.methodPay" autocomplete="ño" disabled)
              option(v-for="method in methods" :key="'m-' + method" :value="method") {{ capitalize(method) }}
            label.label.disabled(:class="{ show: dataForm.methodPay }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="methodPay" title="Método de Pago")
          .input-container
            input.input(v-model="dataForm.methodPayCost" autocomplete="ño" disabled required)
            label.label.disabled(:class="{ show: dataForm.methodPayCost >= 0 }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="methodPayCost" title="Costo Del Método de Pago")

        .form-section
          .input-container(v-if="dataForm.tip")
            input.input(v-model="dataForm.tip" autocomplete="ño" disabled required)
            label.label.disabled(:class="{ show: dataForm.tip >= 0 }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="tip" title="Propina")

        .input-container(v-if="dataForm.adviser")
          .input.disabled
            shNameUser(:dni="dataForm.adviser")
          label.label.disabled.capitalize(:class="{ show: dataForm.adviser }") Asesor

        .input-container(v-if="dataForm.codeName")
          input.input(v-model="dataForm.codeName" autocomplete="ño" disabled required)
          label.label.disabled(:class="{ show : dataForm.codeName }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="codeName" title="Código Promocional")

        .input-container(v-if="dataForm.codeName")
          input.input(v-model="dataForm.codePercent" autocomplete="ño" disabled required)
          label.label.disabled(:class="{ show: dataForm.codePercent >= 0 }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="codePercent" title="Porcentaje Código Promocional")

        .input-container(v-if="dataForm.codeName")
          input.input(v-model="dataForm.codeValue" autocomplete="ño" disabled required)
          label.label.disabled(:class="{ show: dataForm.codeValue >= 0 }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="codeValue" title="Valor Código Promocional")

        .form-section.form-order-actions
          shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")
          shActionButton(v-if="fillData && buyerDataLocked" :action="unlockOrderData" text="Desbloquear" textRunning="Desbloqueando" :textConfirmation="unlockOrderDataConfirmation")

  .section-title(@click="showSection('products')" name="SectionTitle")
    h3.capitalize
      span Productos
      span.tag.tag-sale(v-if="dataForm.isSale") Sale
      span.tag {{quantity}}
      span.tag {{ money(totalProducts) }}

  transition(name="slide-fade")
    .section-container(v-if="show.products")
      .products-order-container
        shProduct(v-for="product in dataForm.cart" :key="product.product" :order="dataForm" :quantity="quantity" :product="product" @updateProduct="updateProduct" :subtract="dataForm.status === 'created' || dataForm.status === 'approved'" :pick="dataForm.status === 'paid'" :allowPick="canPickProducts" :quantitySale="dataForm.quantitySale")

      .products-order-container.product-change-pending-list(v-if="pendingProductChange && pendingProductChangeItem")
        .product-change-pending-wrap
          shProduct(
            :order="dataForm"
            :product="pendingProductChangeItem"
            :quantity="quantity"
            :subtract="false"
            :pick="false"
            :isProductChange="true"
            :hidePack="true"
            :hideDescription="true"
            :quantitySale="dataForm.quantitySale"
          )
          .product-change-pending__bar
            span.product-change-pending__sizes.uppercase {{ pendingProductChange.from }} → {{ pendingProductChange.to }}
            .product-change-pending__actions
              router-link.product-change-pending__link(
                :to="{ name: 'OrderDataNovelties', params: { code: dataForm.order } }"
              ) Alistar
              shActionButton(
                :action="cancelProductChange"
                text="Eliminar"
                textRunning="Eliminando"
                textConfirmation="¿Eliminar el cambio de talla pendiente?"
                :normalColor="true"
                :mini="true"
              )

      div(v-if="dataForm.status === 'paid' && canPickProducts")
        form(@submit.prevent="")
          .input-container
            input.input(v-model="productCheck" @keypress.enter.prevent="checkProduct" autocomplete="ño" required)
            label.label(:class="{ show: productCheck }") Ingresa el Código Del Producto
          shActionButton(:isForm="true" :action="checkProduct" :params="[product]" text="Revisar Producto" textRunning="Revisando Producto" :normalColor="true")

      .products-order-container(v-if="dataForm.status === 'created' || dataForm.status === 'approved'")
        shProduct(v-for="(product, index) in addProducts" :key="product.product" :order="dataForm" :quantity="quantity" :product="product" :add="true" @updateProduct="updateProduct")

      div(v-if="dataForm.status === 'created' || dataForm.status === 'approved'")
        .input-container
          input.input(v-model="product" @keypress.enter.prevent="addProduct" autocomplete="ño")
          label.label(:class="{ show: product }") Escribe la referencia
        shActionButton(:action="addProduct" text="Buscar Producto" textRunning="Buscando Producto")

  .section-title(@click="show.observations = !show.observations")
    h3.capitalize
      span Observaciones
      span.tag(v-if="dataForm.observations && dataForm.observations.length") {{ dataForm.observations.length }}

  transition(name="slide-fade")
    .section-container(v-if="show.observations")
      .observations-container
        .observation.list-items.dark.capitalize(v-if="dataForm.observations && dataForm.observations.length")
          .observation-observation Observación
          .observation-type Tipo
          .observation-created-at Fecha Creación
          .observation-created-by Creado Por
        .observation.list-items(v-for="(observation, index) in dataForm.observations" :key="observation.createdAt" v-if="observation")
          .observation-observation {{ index + 1 }}. {{ observation.observation }}
          .observation-type {{ observation.type }}
          .observation-created-at {{ dateTime(observation.createdAt) }}
          shNameUser.observation-created-by(:dni="observation.createdBy")

      form(@submit.prevent="")
        .input-container
          textarea.input(v-model="observation.observation" autocomplete="ño" rows="3" required)
          label.label.capitalize(:class="{ show: observation.observation }") {{ text.labels.observation }}

        .input-container.arrow.arrow-icon
          select.select.capitalize(v-model="observation.type" autocomplete="ño" required)
            option(value="" select)
            option(value="delivery") Entrega
            option(value="pay") Pago
            option(value="product") Producto
            option(value="support") Soporte
            option(value="recovery") Recuperación
          label.label.capitalize(:class="{ show: observation.type }") Tipo

        shActionButton(:isForm="true" :action="addObservation" text="Agregar Observación" textRunning="Agregando Observación" :normalColor="true")

  .section-title(@click="show.productChanges = !show.productChanges")
    h3
      span Cambios Productos
      span.tag(v-if="productChangeHistoryEntries.length") {{ productChangeHistoryEntries.length }}

  transition(name="slide-fade")
    .section-container(v-if="show.productChanges")
      .observations-container
        .observation.list-items.dark.capitalize(v-if="productChangeHistoryEntries.length")
          .product-change-product Producto
          .product-change-sizes Cambio
          .product-change-action Acción
          .product-change-reason Motivo
          .observation-created-at Fecha
          .observation-created-by Creado Por
        .observation.list-items(v-for="(entry, index) in productChangeHistoryEntries" :key="productChangeHistoryKey(entry, index)")
          .product-change-product {{ entry.product || '—' }}
          .product-change-sizes {{ entry.from }} → {{ entry.to }}
          .product-change-action {{ productChangeActionLabel(entry.action) }}
          .product-change-reason {{ productChangeReasonLabel(entry.reason) }}
          .observation-created-at {{ dateTime(entry.createdAt) }}
          shNameUser.observation-created-by(:dni="entry.createdBy")
        p(v-if="!productChangeHistoryEntries.length") No hay cambios de producto

  .section-title(@click="show.pay = !show.pay")
    h3
      span.capitalize Pagos
      span.color-red.tag(v-if="pendingBalance > 0")  - {{ money(pendingBalance) }}
      span.color-green.tag(v-else)  {{ money(pendingBalance) }}

  transition(name="slide-fade")
    .section-container(v-if="show.pay")
      .pay-u-container
        .title-pay
          span Automáticos
          .tag {{ money(totalPayU) }}

        .list-items.dark.capitalize
          .item-pay-u Id
          .item-pay-u Método
          .item-pay-u Estado
          .item-pay-u valor
          .item-pay-u Creación
          .item-pay-u Revisado
          .item-pay-u Acciones

        .list-items(v-for="(pay, index) in dataOriginal.payU")
          .item-pay-u
            .item-pay-u-platform-user(v-if="pay.platformUser")
              div {{ pay.platformUserName || pay.platformUser }} - {{ pay.platform }}
            a.item-pay-u-order-id(v-if="pay.platform === 'wompi' && pay.orderId" :href="`https://login.wompi.co/`" target="_blank" rel="noopener noreferrer" @click="copyWompiOrderId(pay.orderId)") {{ pay.orderId }}
            .item-pay-u-order-id(v-else) {{ pay.orderId || 'No Id' }}
          .item-pay-u
            div
              img.method-pay-image(:src="`${imagePath}/methods/light/${pay.methodPay}.png`" :alt="pay.methodPay")
            div(v-if="pay.methodPay === 'daviplata'") {{ pay.daviplataPhone }}
            div(v-if="pay.methodPay === 'nequi'") {{ pay.nequiPhone }}
            div.item-pay-u-order-id.capitalize(v-if="pay.cardType") {{ pay.cardType }}
            div.item-pay-u-order-id(v-if="pay.bin") BIN {{ pay.bin }}
            div.item-pay-u-order-id(v-if="pay.lastFour") **** {{ pay.lastFour }}
            div(v-if="pay.methodPay === 'addi' && pay.status === 'pending'")
              shActionButton(text="Copiar URL" textRunning="Copiar URL" :action="copyUrl" :params="[pay.redirectUrl]" :mini="true")
          .item-pay-u(:class="{'color-green': pay.state === 'approved', 'color-red': pay.state !== 'approved' && pay.state !== 'created'}")
            .capitalize {{ statesSpanish[pay.state] || 'invalida' }}
            div(v-if="pay.methodPay === 'daviplata' && pay.state === 'pending' && pay.tokenExpirationDate")
              div Vence:
              div {{ dateTime(pay.tokenExpirationDate, true) }}
            .capitalize(v-if="pay.error") {{ pay.error }}
          .item-pay-u {{ money(pay.value || 0) }}
          .item-pay-u {{ dateName(pay.createdAt) }} - {{ time(pay.createdAt) }}
          .item-pay-u {{ dateName(pay.checkedAt || pay.createdAt) }} - {{ time(pay.checkedAt || pay.createdAt) }}
          .item-pay-u
            shActionButton(v-if="pay.orderId && pay.methodPay !== 'addi'" :action="checkStatePayU" :params="[index, pay.platform]" text="Actualizar" textRunning="Actualizando")

      .pay-manual.container
        .title-pay
          span Manuales
          .tag {{ money(totalPayManual) }}

        .list-items.dark.capitalize
          .item-pay-manual Imagen
          .item-pay-manual Método
          .item-pay-manual Estado
          .item-pay-manual Valor
          .item-pay-manual Creación
          .item-pay-manual Creado Por
          .item-pay-manual Acciones

        .list-items(v-for="(pay, index) in dataOriginal.payManual")
          .item-pay-manual.receipt
            .receipt-image(v-if="pay.receipt")
              shImageZoom(:isImage="true")
                img.receipt-image(:src="`${imagePath}/receipts/pays/${pay.receipt}.jpg`" alt="comprobante")
            shActionButton(v-if="pay.receipt && (pay.state === 'pending' || pay.state === 'declined')" :action="deleteImageReceipt" :params="[index]" text="Eliminar" textRunning="Eliminando" :mini="true" :textConfirmation="'Eliminaras el comprobante de pago'")
            input(type="file" :ref="`fileInput${index}`" @change="handleFileSelect($event, index)" accept="image/*" style="display: none")
            shActionButton(v-if="!pay.receipt && pay.state === 'pending'" :action="selectFile" :params="[index]" text="Agregar" textRunning="Actualizando" :mini="true")
          .item-pay-manual
            img.method-pay-image(:src="`${imagePath}/methods/light/${pay.methodPay}.png`" :alt="pay.methodPay")
          .item-pay-manual(:class="{'color-green': pay.state === 'approved', 'color-red': pay.state === 'declined'}") {{ pay.state }}
          .item-pay-manual {{ money(pay.value || 0) }}

          .item-pay-manual {{ dateName(pay.createdAt) }} - {{ time(pay.createdAt) }}
          .item-pay-manual
            shNameUser.item-pay-manual(:dni="pay.createdBy")
          .item-pay-manual.gap-column
            shActionButton(v-if="pay.state !== 'declined'"  :action="declinePayManual" :params="[index]" text="Declinar" textRunning="Declinando")
            shActionButton(v-if="pay.state === 'pending'" :action="approvePayManual" :params="[index]" text="Aprobar" textRunning="Aprobando")

        form.add-manual-pays(v-if="dataForm.status === 'created' || dataForm.status === 'approved'" @submit.prevent="")
          .input-container.arrow
            select.select(v-model="manualPay.methodPay" autocomplete="ño" required)
              option(v-for="method in methods" :value="method") {{ capitalize(method) }}
            label.label(:class="{ show: manualPay.methodPay }") Método de Pago

          .input-container
            input.input(v-model.number="manualPay.value" type="number" min="1" max="10000000" autocomplete="ño" required)
            label.label.capitalize(:class="{ show: manualPay.value }") Valor

          shActionButton.button-pay(:isForm="true" :action="addPayManual" text="Agregar Pago" textRunning="Agregando Pago" :normalColor="true")

  .section-title(@click="show.history = !show.history")
    h3.capitalize Historial

  transition(name="slide-fade")
    .section-container(v-if="show.history")
      .list-items.dark.capitalize
        .item-history Estado
        .item-history Usuario
        .item-history Fecha

      .list-items(v-for="(entry, index) in statusHistoryDisplay" :key="`${entry.createdAt}-${entry.status}-${index}`")
        .item-history.capitalize {{ orderStatusLabel(entry.status) }}
        .item-history
          shNameUser(v-if="entry.createdBy" :dni="entry.createdBy")
          span(v-else) —
        .item-history {{ dateName(entry.createdAt) + ' - ' + time(entry.createdAt)}}

  .section-title(@click="show.delivery = !show.delivery")
    h3
      span.capitalize Entregas
      span.tag(v-if="dataOriginal.deliveries && dataOriginal.deliveries.length") {{ dataOriginal.deliveries.length }}

  transition(name="slide-fade")
    .section-container(v-if="show.delivery")
      .list-items.dark.capitalize.delivery-header(v-if="dataOriginal.deliveries ? dataOriginal.deliveries.length : false")
        .item-delivery {{ text.tables.delivery }}
        .item-delivery {{ text.tables.state }}
        .item-delivery {{ text.tables.conveyor }}
        .item-delivery {{ text.tables.tracking }}
        .item-delivery {{ text.tables.createdAt }}
        shExpandButton.hidden(:expand="show.delivery")

      shDelivery(v-for="(delivery, index) in sortedDeliveries" :delivery="delivery" :text="text" :conveyors="conveyors" :key="delivery.delivery")

  .section-title(@click="show.change = !show.change")
    h3
      span.capitalize Cambios
      span.tag(v-if="dataOriginal.changes && dataOriginal.changes.length") {{ dataOriginal.changes.length }}

  transition(name="slide-fade")
    .section-container(v-if="show.change")
      .refund-order-container
        .list-items.form.dark
          .item-refund Creación
          .item-refund.capitalize Id de Cambio
          .item-refund.capitalize Estado
          .item-refund Ver
      shChange(v-for="(change, index) in dataOriginal.changes" :change="change" :key="change.change")

      div
        h3 Nuevo Cambio
        form(@submit.prevent="")
          .input-container.arrow.arrow-icon(v-for="(reason, index) in newChangeData.reasons")
            select.select.capitalize(v-model="newChangeData.reasons[index]" autocomplete="ño" @change="addOrDeleteReason(index)")
              option(value="" select)
              option(value="11") Cliente: Eligió mal talla
              option(value="12") Cliente: No gustó material
              option(value="13") Cliente: No gustó prenda
              option(value="14") Cliente: No gustó color
              option(value="21") Sahet: Talla incorrecta
              option(value="22") Sahet: Referencia incorrecta
              option(value="23") Sahet: Color no coincide con la imagen
              option(value="24") Sahet: Producto defectuoso
              option(value="25") Sahet: Error asesor al hacer la orden
              option(value="26") Sahet: Mal etiquetado
            label.label.capitalize(:class="{ show: newChangeData.reasons[index] }") Razón Del Cambio

          .checkbox-section
            .input-container-checkbox
              label.label-checkbox(:for="`waitPackage${dataForm.order}`") Esperar Paquete
                input.input-checkbox(v-model="newChangeData.waitPackage" :id="`waitPackage${dataForm.order}`" type="checkbox")
                .checkmark

          .checkbox-section
            .input-container-checkbox
              label.label-checkbox(:for="`conveyorPaidByCompany${dataForm.order}`") Transporte pagado por Sahet
                input.input-checkbox(v-model="newChangeData.conveyorPaidByCompany" :id="`conveyorPaidByCompany${dataForm.order}`" type="checkbox")
                .checkmark

          shActionButton(:isForm="true" :action="newChange" text="Crear Cambio" textRunning="Creando Cambio")

  .section-title(@click="show.bonusApplied = !show.bonusApplied")
    h3
      span.capitalize Bonos aplicados
      span.tag.color-yellow(v-if="dataForm.bonusesApplied && dataForm.bonusesApplied.length > 0") {{ dataForm.bonusesApplied.length }}
      span.tag.color-yellow(v-if="dataForm.bonusesTotal") {{ money(dataForm.bonusesTotal || 0) }}

  transition(name="slide-fade")
    .section-container(v-if="show.bonusApplied && (dataOriginal.status === 'created' || (dataOriginal.bonusesApplied && dataOriginal.bonusesApplied.length))")
      .pay-bonuses.container
        form.add-bonus-row(v-if="dataOriginal.status === 'created'" @submit.prevent="")
          .bonus-phone-hint(v-if="isLoadingAvailableBonuses") Buscando bonos disponibles…
          .bonus-phone-hint(v-else-if="!availableBonusesForOrder.length") No hay bonos disponibles para agregar con estos teléfonos.
          .input-container.arrow(v-if="availableBonusesForOrder.length")
            select.select(v-model="bonusCodeToAdd" autocomplete="off" required)
              option(value="") Selecciona un bono
              option(v-for="b in availableBonusesForOrder" :key="b.bonus" :value="b.bonus")
                | {{ b.bonus }} — {{ money(b.remainingValue) }} ({{ b.status === 'created' ? 'Pendiente' : 'Aprobado' }})
            label.label(:class="{ show: bonusCodeToAdd }") Bono disponible
          .bonus-phone-hint(v-if="(dataOriginal.bonusesApplied || []).length > 1") Para quitar varios bonos, hay que hacerlo desde el último agregado hacia atrás (uno por vez).
          shActionButton.button-pay(
            v-if="availableBonusesForOrder.length"
            :isForm="true"
            :action="addBonusToOrder"
            text="Agregar bono"
            textRunning="Agregando…"
            :normalColor="true"
          )

        .list-items.dark.capitalize(v-if="dataOriginal.bonusesApplied && dataOriginal.bonusesApplied.length")
          .item-bonus Bono
          .item-bonus Valor Usado
          .item-bonus Estado
          .item-bonus Fecha
          .item-bonus.bonus-remove(v-if="dataOriginal.status === 'created'")

        .list-items(v-for="(b, bonusIndex) in (dataOriginal.bonusesApplied || [])" :key="b.bonus")
          .item-bonus.dark
            a.bonus-link(:href="`/bonuses?bonus=${b.bonus}`" target="_blank") {{ b.bonus }}
          .item-bonus {{ money(getBonusValueUsed(b)) }}
          .item-bonus(:class="{ 'color-yellow': b.status === 'created', 'color-blue': b.status === 'approved' }")
            | {{ b.status === 'created' ? 'Pendiente' : b.status === 'approved' ? 'Aprobado' : b.status }}
          .item-bonus {{ getBonusUsedAt(b) ? dateName(getBonusUsedAt(b)) + ' - ' + time(getBonusUsedAt(b)) : '—' }}
          .item-bonus.bonus-remove(v-if="dataOriginal.status === 'created'")
            shActionButton(
              v-if="bonusIndex === bonusRemoveLastIndex"
              :action="removeBonusFromOrder"
              :params="[b.bonus]"
              text="×"
              textRunning="x"
              :mini="true"
              :textConfirmation="`¿Quitar el bono ${b.bonus} de este pedido?`"
              warning
            )
            span.bonus-remove-placeholder(
              v-else
              title="Solo se puede quitar el último bono aplicado (de último al primero)."
            ) —

  .section-title(@click="show.bonusIssued = !show.bonusIssued")
    h3
      span.capitalize Bonos
      span.tag(v-if="(dataOriginal.bonuses || []).length") {{ (dataOriginal.bonuses || []).length }}

  transition(name="slide-fade")
    .section-container(v-if="show.bonusIssued && (dataOriginal.bonuses || []).length")
      .pay-bonuses-issued.container
        .bonus-phone-hint Bonos CustomerBonus emitidos desde esta orden (por ejemplo reembolso en bono).
        .list-items.dark.capitalize
          .item-bonus Bono
          .item-bonus Saldo inicial
          .item-bonus Estado
        .list-items(v-for="ob in (dataOriginal.bonuses || [])" :key="ob.bonus")
          .item-bonus.dark
            a.bonus-link(:href="`/bonuses?bonus=${ob.bonus}`" target="_blank") {{ ob.bonus }}
          .item-bonus {{ money(ob.originalValue || 0) }}
          .item-bonus(:class="{ 'color-yellow': ob.status === 'created', 'color-blue': ob.status === 'approved' }")
            | {{ ob.status === 'created' ? 'Pendiente' : ob.status === 'approved' ? 'Aprobado' : ob.status }}

  .section-title(@click="show.refund = !show.refund")
    h3
      span.capitalize Reembolsos
      span.tag(v-if="dataOriginal.refunds && dataOriginal.refunds.length") {{ dataOriginal.refunds.length }}

  transition(name="slide-fade")
    .section-container(v-if="show.refund")
      .list-items.dark.capitalize(v-if="dataOriginal.refunds && dataOriginal.refunds.length")
        .item-refund {{ text.tables.refound }}
        .item-refund {{ text.tables.why }}
        .item-refund {{ text.tables.state }}
        .item-refund {{ text.tables.method }}
        .item-refund {{ text.tables.value }}
        .item-refund {{ text.tables.createdAt }}
        shExpandButton.hidden(:expand="show.refund")

      shRefund(v-for="(refund, index) in dataOriginal.refunds" :refund="refund" :text="text" :key="refund.refund")

  .section-title(@click="show.invoice = !show.invoice")
    h3
      span.capitalize Facturas
      span.tag(v-if="dataOriginal.invoices && dataOriginal.invoices.length") {{ dataOriginal.invoices.length }}

  transition(name="slide-fade")
    .section-container(v-if="show.invoice")
      div(v-for="invoice in dataOriginal.invoices")
        .input-container
          input.input(v-model="invoice.status" type="text" autocomplete="ño" disabled)
          label.label.capitalize(:class="{ show: invoice.status }") Estado de la Factura
        .input-container
          input.input(v-model="invoice.value" type="number" autocomplete="ño" disabled)
          label.label.capitalize(:class="{ show: invoice.value }") Valor de la Factura
        .input-container
          input.input(v-model="invoice.tascode" type="text" autocomplete="ño" disabled)
          label.label.capitalize(:class="{ show: invoice.tascode }") Tas Code

      form(v-if="" @submit.prevent="")
        .input-container
          select.select(v-model="personType" :class="{ show: personType }" autocomplete="ño" required)
            option(value="natural") Natural
            option(value="juridica") Jurídica
          label.label.capitalize(:class="{ show: personType }") Tipo de Persona

        .input-container
          select.select(v-model="documentType" :class="{ show: documentType }" autocomplete="ño" required)
            option(value="cc") Cédula
            option(value="nit") NIT
            option(value="ce") Cédula de Extranjería
          label.label.capitalize(:class="{ show: documentType }") Tipo de Documento

        .input-container
          select.select(v-model="sendEmail" :class="{ show: sendEmail }" autocomplete="ño" required)
            option(:value="true") Sí
            option(:value="false") No
          label.label.capitalize(:class="{ show: sendEmail === false || sendEmail === true }") Enviar Email

        shActionButton(v-if="true" :isForm="true" :action="createInvoice" text="Crear Factura" textRunning="Creando Factura")

  .section-title(@click="show.others = !show.others")
    h3
      span.capitalize Otros

  transition(name="slide-fade")
    .section-container(v-if="show.others")
      .input-container.arrow
        select.select.capitalize(v-model="dataForm.methodPay" autocomplete="ño")
          option(v-for="method in methodsForChangePay" :key="method" :value="method") {{ capitalize(method) }}
        label.label.capitalize(:class="{ show: !!dataForm.methodPay }") Método de Pago

      shActionButton(:action="changeMethodPay" text="Cambiar Método" textRunning="Cambiando Método")

      .input-container.arrow
        select.select(v-model="dataForm.userPayConveyor" autocomplete="ño")
          option(:value="true") Sí
          option(:value="false") No
        label.label.capitalize(:class="{ show: typeof dataForm.userPayConveyor === 'boolean' }") Envío al cobro

      shActionButton(:action="changeUserPayConveyor" text="Actualizar envío al cobro" textRunning="Actualizando…")

      .input-container.arrow
        select.select(v-model="dataForm.isWholesaler" autocomplete="ño")
          option(:value="true") Sí
          option(:value="false") No
        label.label.capitalize(:class="{ show: typeof dataForm.isWholesaler === 'boolean' }") Es Mayorista

      shActionButton(:action="changeIsWholesaler" text="Cambiar Tipo de Orden" textRunning="Cambiando Tipo de Orden")

      .input-container.arrow
        select.select(v-model="dataForm.paidWholesaler" autocomplete="ño")
          option(value="")
          option(:value="true") Sí
          option(:value="false") No
        label.label.capitalize(:class="{ show: typeof dataForm.paidWholesaler === 'boolean' }") Orden Pagada

      shActionButton(:action="paidOrder" text="Cambiar" textRunning="Cambiando")

      .special-section
        h3 Acciones Especiales
        .specials-buttons
          shActionButton(:action="banUser" :params="[dataForm.order]" text="Banear" textRunning="Baneando" textConfirmation="¿Estás seguro de banear este usuario?")
          shActionButton(:action="deleteOrder" :params="[dataForm.order]" text="Eliminar" textRunning="Eliminando" textConfirmation="¿Estás seguro de eliminar esta orden?")

      .tracking-section(v-if="dataOriginal.tracking")
        h3 Tracking
        .tracking-scalars
          .input-container(v-for="field in trackingScalarFields" :key="field.key")
            textarea.input(v-if="field.multiline" :value="field.value" rows="3" autocomplete="ño" disabled)
            input.input(v-else :value="field.value" autocomplete="ño" disabled)
            label.label.disabled.show {{ field.label }}

        .tracking-array(v-if="dataOriginal.tracking.addedCart && dataOriginal.tracking.addedCart.length")
          h4 Carrito agregado
          .list-items.dark.capitalize
            .item-tracking Producto
            .item-tracking Artículo
            .item-tracking Talla
            .item-tracking Precio unitario
          .list-items(v-for="(item, index) in dataOriginal.tracking.addedCart" :key="`cart-${index}`")
            .item-tracking {{ item.product || '-' }}
            .item-tracking.capitalize {{ item.article || '-' }}
            .item-tracking {{ item.size || '-' }}
            .item-tracking {{ money(item.priceUnit) }}

        .tracking-array(v-if="dataOriginal.tracking.addedFilter && dataOriginal.tracking.addedFilter.length")
          h4 Filtros usados
          .list-items.dark.capitalize
            .item-tracking Tipo
            .item-tracking Valor
          .list-items(v-for="(item, index) in dataOriginal.tracking.addedFilter" :key="`filter-${index}`")
            .item-tracking {{ item.type || '-' }}
            .item-tracking {{ item.value || '-' }}

        .tracking-array(v-if="dataOriginal.tracking.trackAds && dataOriginal.tracking.trackAds.length")
          h4 Ads
          .list-items.dark.capitalize
            .item-tracking Clave
            .item-tracking Valor
          .list-items(v-for="(item, index) in dataOriginal.tracking.trackAds" :key="`ads-${index}`")
            .item-tracking {{ item.key || '-' }}
            .item-tracking {{ item.value || '-' }}

        .tracking-array(v-if="dataOriginal.tracking.trackSocial && dataOriginal.tracking.trackSocial.length")
          h4 Social
          .list-items.dark.capitalize
            .item-tracking Clave
            .item-tracking Valor
          .list-items(v-for="(item, index) in dataOriginal.tracking.trackSocial" :key="`social-${index}`")
            .item-tracking {{ item.key || '-' }}
            .item-tracking {{ item.value || '-' }}

        .tracking-array(v-if="dataOriginal.tracking.trackStore && dataOriginal.tracking.trackStore.length")
          h4 Store
          .list-items.dark.capitalize
            .item-tracking Clave
            .item-tracking Valor
          .list-items(v-for="(item, index) in dataOriginal.tracking.trackStore" :key="`store-${index}`")
            .item-tracking {{ item.key || '-' }}
            .item-tracking {{ item.value || '-' }}

  StaffRequestRefundModal(
    ref="staffRefundModal"
    :order="dataOriginal"
    :image-path-base="imagePath"
    @refresh="refreshOrdersAfterStaffRefund"
  )

  UnpickTierModal(
    :show="unpickTierModal.show"
    :picked-tier="unpickTierModal.pickedTier"
    :item="unpickTierModal.item"
    :busy="unpickTierModal.busy"
    @close="closeUnpickTierModal"
    @select="onUnpickTierSelect"
  )

  ChangeSizeModal(
    :show="changeSizeModal.show"
    :item="changeSizeModal.item"
    :order="dataForm.order"
    :picked-from-tier="changeSizeModal.pickedFromTier"
    :busy="changeSizeModal.busy"
    @close="closeChangeSizeModal"
    @confirm="onChangeSizeConfirm"
  )
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import gqlLocation from '@/graphql/location'
import gqlProduct from '@/graphql/product'
import gqlChange from '@/graphql/change'
import gqlInvoice from '@/graphql/invoice'
import shInputList from '@/components/elements/InputList'
import shInputListNumber from '@/components/elements/InputListNumber'
import shSelectList from '@/components/elements/SelectList'
import shInputImageList from '@/components/elements/InputImageList'
import shInputImage from '@/components/elements/InputImage'
import shProduct from '@/components/ecommerce/Product'
import shNameUser from '@/components/elements/NameUser'
import shExpandButton from '@/components/elements/ExpandButton'
import modals from '@my/store/modals'
import shDelivery from './Delivery.vue'
import shRefund from './Refund.vue'
import shChange from './Change.vue'
import shOrderAddressMap from './OrderAddressMap.vue'
import StaffRequestRefundModal from '@/components/pages/order/refund/StaffRequestRefundModal.vue'
import UnpickTierModal from '@/components/pages/order/UnpickTierModal.vue'
import ChangeSizeModal from '@/components/pages/order/ChangeSizeModal.vue'
import auth from '@my/authentication'
import { isBlockedByFraud } from '@/helpers/fraudReview'
import { parseProductCode } from '@/helpers/packSearch'
import { PRODUCT_CHANGE_REJECT_REASONS } from '@/helpers/orderNovelty'
import { DATA_CHANGE_TYPES, getDataHistoryByType, getLocationHistoryEntries } from '@/helpers/orderDataHistory'
import shOrderDataHistory from '@/components/elements/order/OrderDataHistory'

export default {
  name: 'FormOrder',

  mixins: [mForm, mFilters, mDB],

  components: { shSelectList, shInputImageList, shInputImage, shInputList, shInputListNumber, shProduct, shNameUser, shExpandButton, shDelivery, shRefund, shChange, StaffRequestRefundModal, UnpickTierModal, ChangeSizeModal, shOrderAddressMap, shOrderDataHistory },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        order: '',
        status: '',
        name: '',
        phones: [],
        address: '',
        location: '',
        department: '',
        methodPay: '',
        methodPayCost: 0,
        deliveryCost: [],
        conveyor: '',
        conveyorCost: 0,
        userPayConveyor: false,
        codeName: '',
        codeType: '',
        codePercent: 0,
        codeValue: 0,
        tip: 0,
        deliveryTime: '',
        isWholesaler: false,
        isDropshipping: false,
        deliveryMan: '',
        deliveryTracking: [],
        mpCode: '',
        cart: [],
        declinedBy: '',
        declinedAt: '',
        approvedBy: '',
        approvedAt: '',
        paidBy: '',
        paidAt: '',
        sentBy: '',
        sentAt: '',
        observations: [],
        paidWholesaler: ''
      },
      resolver: 'order',
      key: 'order',
      gql: gqlOrder,
      deliverySchedule: [{ value: '8-21', option: '🌞 8:00 a.m. - 🌚 9:00 p.m.' }, { value: '8-20', option: '🌞 8:00 a.m. - 🌛 8:00 p.m.' }, { value: '8-13', option: '🌞 8:00 a.m. - 😎 1:00 p.m.' }, { value: '13-20', option: '😎 1:00 p.m. - 🌛 8:00 p.m.' }, { value: '13-21', option: '😎 1:00 p.m. - 🌚 9:00 p.m.' }],
      communities: ['bosa', 'barrios unidos', 'candelaria', 'chapinero', 'engativá', 'fontibón', 'kennedy', 'los mártires', 'puente aranda', 'rafael uribe', 'san cristóbal', 'santa fe', 'santa isabel', 'suba', 'teusaquillo', 'tunjuelito', 'usaquén', 'usme', 'no conozco la localidad'],
      search: '',
      showLocations: false,
      locationsFiltered: [],
      searched: false,
      hoverLocation: -1,
      locationSearchTimeoutId: null,
      locationSearchDelay: 300,
      addProducts: {},
      product: '',
      productCheck: '',
      delete: ['order', 'cart', 'createdAt', 'updatedAt', 'declinedAt', 'declinedBy', 'approvedAt', 'approvedBy', 'pendingAt', 'pendingBy', 'paidAt', 'paidBy', 'sentAt', 'sentBy', 'packedAt', 'packedBy', 'deliveryTracking', 'payManual', 'observations', 'statusHistory', 'collectedAt', 'collectedBy', 'collectedValue', 'payU', 'deliveries', 'refunds', 'recoveredAt', 'isSale', 'invoices', 'paidWholesaler', 'quantitySale', 'bonuses', 'bonusesApplied', 'bonusesTotal', 'conveyorCost', 'userPayConveyor', 'expirationDate', 'changes', 'lat', 'lng', 'remitData', 'remitDataGenerated', 'dataLocked', 'hasNoveltyData', 'noveltyData', 'hasProductChange', 'productChange', 'productChangeHistory'],
      manualPay: {
        methodPay: '',
        value: ''
      },
      bonusCodeToAdd: '',
      availableBonusesForOrder: [],
      isLoadingAvailableBonuses: false,
      pack: {
        code: '',
        currentTier: '',
        sounds: {
          beepError: 'beep_error.mp3',
          beep: 'beep.mp3',
          error: 'error.mp3',
          tier: 'tier.mp3',
          product: 'product.mp3'
        }
      },
      observation: {
        observation: '',
        type: ''
      },
      show: {
        observations: false,
        productChanges: false,
        products: false,
        data: false,
        pay: false,
        history: false,
        delivery: false,
        refund: false,
        invoice: false,
        change: false,
        others: false,
        bonusApplied: false,
        bonusIssued: false
      },
      personType: 'natural',
      documentType: 'cc',
      sendEmail: false,
      statesSpanish: {
        voided: 'anulada',
        approved: 'aprobada',
        declined: 'rechazada',
        pending: 'pendiente',
        failed: 'fallida',
        reversed: 'reversada',
        retained: 'retenido',
        inited: 'iniciada',
        expired: 'caducada',
        abandoned: 'abandonada',
        cancelled: 'cancelada',
        rejected: 'rechazado',
        error: 'error'
      },
      orderStatusSpanish: {
        created: 'Creado',
        approved: 'Aprobado',
        paid: 'Pagado',
        packed: 'Empacado',
        sent: 'Enviado',
        declined: 'Declinado',
        expired: 'Expirado',
        disapproved: 'Desaprobado',
        unpaid: 'Despagado',
        unpacked: 'Desempacado',
        unsent: 'Envío revertido',
        uncollected: 'Cobro devuelto',
        recovered: 'Recuperado'
      },
      audios: {
        beepError: '',
        beep: '',
        error: '',
        tier: '',
        product: ''
      },
      sounds: {
        beepError: 'beep_error.mp3',
        beep: 'beep.mp3',
        error: 'error.mp3',
        tier: 'tier.mp3',
        product: 'product.mp3'
      },
      newChangeData: {
        reasons: [''],
        waitPackage: true,
        conveyorPaidByCompany: false
      },
      sizes: {
        xs: '26',
        s: '28',
        m: '30',
        l: '32',
        xl: '34',
        xxl: '36'
      },
      unpickTierModal: {
        show: false,
        pickedTier: '',
        item: null,
        busy: false,
        resolve: null,
        reject: null
      },
      changeSizeModal: {
        show: false,
        pickedFromTier: '',
        item: null,
        busy: false,
        resolve: null,
        reject: null
      }
    }
  },

  provide () {
    return {
      chooseUnpickReturnTier: this.chooseUnpickReturnTier,
      chooseChangeSize: this.chooseChangeSize
    }
  },

  created () {
    if (this.fillData) {
      this.dataForm = this.copyObject(this.dataOriginal)
      if (typeof this.dataForm.userPayConveyor !== 'boolean') {
        this.$set(this.dataForm, 'userPayConveyor', !!this.dataForm.userPayConveyor)
      }
      if (typeof this.dataForm.isWholesaler !== 'boolean') {
        this.$set(this.dataForm, 'isWholesaler', !!this.dataForm.isWholesaler)
      }
    }
  },

  methods: {
    getBonusValueUsed (bonus) {
      const tx = bonus.transactions && bonus.transactions.find(t => t.order === this.dataOriginal.order)
      return tx ? tx.valueUsed : bonus.usedValue
    },

    getBonusUsedAt (bonus) {
      const tx = bonus.transactions && bonus.transactions.find(t => t.order === this.dataOriginal.order)
      return tx ? tx.usedAt : null
    },

    async loadAvailableBonusesForOrder () {
      if (this.dataOriginal.status !== 'created') {
        this.availableBonusesForOrder = []
        return
      }
      const order = this.dataOriginal.order
      if (!order) return

      this.isLoadingAvailableBonuses = true
      try {
        const response = await gql.query(gqlOrder.GET_AVAILABLE_BONUSES_FOR_ORDER, { order }, false)
        this.availableBonusesForOrder = (response && response.data && response.data.getAvailableBonusesForOrder) || []
        if (this.bonusCodeToAdd && !this.availableBonusesForOrder.some(b => b.bonus === this.bonusCodeToAdd)) {
          this.bonusCodeToAdd = ''
        }
      } catch (error) {
        console.error('Error al cargar bonos disponibles:', error)
        this.availableBonusesForOrder = []
      } finally {
        this.isLoadingAvailableBonuses = false
      }
    },

    selectFile (index) {
      this.$refs[`fileInput${index}`][0].click()
    },
    updateProduct ({ product, quantity, index }) {
      if (this.addProducts[product]) {
        const quantityAvailable = this.addProducts[product].quantityAvailable
        this.$set(quantityAvailable, index, quantityAvailable[index] - quantity)
      }
    },

    orderStatusLabel (status) {
      return this.orderStatusSpanish[status] || status
    },

    sendForm () {
      if (!this.fillData) {
        this.newOrder()
      } else {
        this.updateOrder()
      }
    },

    newOrder () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateOrder () {
      const update = this.dataUpdate()

      if (update && this.buyerDataLocked) {
        const lockedFields = ['name', 'phones', 'address', 'location', 'department']

        if (lockedFields.some(field => update[field] !== undefined)) {
          modals.showMessage({
            message: 'No se pueden modificar nombre, teléfono, dirección, ciudad o departamento porque ya se generó un remite.',
            type: 'error'
          })
          this.dataForm = this.copyObject(this.dataOriginal)
          this.resetLocationSearch()
          return
        }
      }

      this.updateData(this.gql, this.resolver, this.key)
    },

    removeAccents (text) {
      return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },

    removePunctuation (text) {
      return text.replace(/[.,/#!$%^&*;:{}=\-_'`~()]/g, '')
    },

    resetLocationSearch () {
      this.search = ''
      this.showLocations = false
      this.locationsFiltered = []
      this.searched = false
      this.hoverLocation = -1
      if (this.locationSearchTimeoutId) {
        clearTimeout(this.locationSearchTimeoutId)
        this.locationSearchTimeoutId = null
      }
    },

    onLocationSearch (event) {
      if (this.buyerDataLocked) return
      if (!event.target || !event.target.value) return

      this.search = event.target.value

      if (event.target.value.length < 2) {
        this.showLocations = false
        this.searched = false
        this.locationsFiltered = []
      } else {
        if (this.locationSearchTimeoutId) clearTimeout(this.locationSearchTimeoutId)

        this.locationSearchTimeoutId = setTimeout(() => {
          this.fetchLocationsFiltered(event)
        }, this.locationSearchDelay)
      }
    },

    async fetchLocationsFiltered (event) {
      this.showLocations = true

      const cleanWord = this.removePunctuation(this.removeAccents(event.target.value.toLowerCase().trim()))
      if (!cleanWord) return

      this.searched = true

      const response = await gql.query(gqlLocation.GET_LOCATIONS_ECOMMERCE_FILTERED, { find: cleanWord })

      if (response && response.data && response.data.getLocationsEcommerceFiltered) {
        this.locationsFiltered = response.data.getLocationsEcommerceFiltered
      } else {
        this.locationsFiltered = []
      }

      this.hoverLocation = -1
    },

    chooseLocation (location) {
      if (!location && this.hoverLocation >= 0) {
        location = this.locationsFiltered[this.hoverLocation]
      }
      if (!location) return

      this.dataForm.location = location.location
      this.dataForm.department = location.department
      this.resetLocationSearch()
    },

    onLocationConfirmedClick () {
      if (this.buyerDataLocked) return
      this.clearLocationForm()
    },

    clearLocationForm () {
      if (this.buyerDataLocked) return

      this.dataForm.location = ''
      this.dataForm.department = ''
      this.resetLocationSearch()

      this.$nextTick(() => {
        if (this.$refs.locationInput) this.$refs.locationInput.focus()
      })
    },

    moveLocationUp () {
      if (this.hoverLocation > 0 && this.locationsFiltered.length) --this.hoverLocation
    },

    moveLocationDown () {
      if (this.hoverLocation < this.locationsFiltered.length - 1 && this.locationsFiltered.length) ++this.hoverLocation
    },

    async unlockOrderData () {
      const mutation = gqlOrder.UNLOCK_ORDER_DATA
      const order = this.dataOriginal.order

      const response = await gql.mutate(mutation, { order })

      if (response) {
        modals.showMessage({ message: 'Orden desbloqueada correctamente' })
      }
    },

    deleteOrder () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    async addProduct () {
      const query = gqlProduct.GET_BY_PRODUCT
      const product = this.product.toLowerCase().trim()

      if (!product) return

      const response = await gql.query(query, { product }, false)

      if (!response) return
      if (!response.data || !response.data.getByProduct) return

      const productFind = response.data.getByProduct
      if (productFind) this.$set(this.addProducts, productFind.product, productFind)

      this.product = ''
    },

    playSoundProduct () {
      if (!this.audios.beep) {
        this.audios.beep = this.playSound(this.sounds.beep)
      } else {
        this.audios.beep.play()
      }

      if (!this.audios.product) {
        this.audios.product = this.playSound(this.sounds.product)
      } else {
        this.audios.product.play()
      }
    },

    playSoundError () {
      if (!this.audios.beepError) {
        this.audios.beepError = this.playSound(this.sounds.beepError)
      } else {
        this.audios.beepError.play()
      }

      if (!this.audios.error) {
        this.audios.error = this.playSound(this.sounds.error)
      } else {
        this.audios.error.play()
      }
    },

    processCode (codeString) {
      const product = parseProductCode(codeString)

      if (!product) {
        this.playSoundError()
        return
      }

      return product
    },

    async checkProduct () {
      const product = this.processCode(this.productCheck.trim())

      if (!product) {
        this.productCheck = ''
        return
      }

      const mutation = gqlOrder.CHECK_PRODUCT_ORDER
      const order = this.dataForm.order

      const response = await gql.mutate(mutation, { order, product: product.product, size: product.size })

      if (response) {
        this.playSoundProduct()
      } else {
        this.playSoundError()
      }

      this.productCheck = ''
    },

    async addPayManual () {
      const query = gqlOrder.ADD_PAY_MANUAL
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, value: this.manualPay.value, methodPay: this.manualPay.methodPay })

      if (response) modals.showMessage({ message: 'Se agregó el pago correctamente' })
    },

    async addBonusToOrder () {
      const bonus = (this.bonusCodeToAdd || '').trim()
      if (!bonus) {
        modals.showMessage({ message: 'Selecciona un bono', type: 'error' })
        return
      }
      const mutation = gqlOrder.ADD_BONUS_TO_ORDER
      const order = this.dataOriginal.order

      const response = await gql.mutate(mutation, { order, bonus })

      if (response) {
        this.bonusCodeToAdd = ''
        modals.showMessage({ message: 'Se agregó el bono al pedido' })
        await this.loadAvailableBonusesForOrder()
      }
    },

    async removeBonusFromOrder (bonusCode) {
      const mutation = gqlOrder.REMOVE_BONUS_FROM_ORDER
      const order = this.dataOriginal.order

      const response = await gql.mutate(mutation, { order, bonus: bonusCode })

      if (response) {
        modals.showMessage({ message: 'Se quitó el bono del pedido' })
        await this.loadAvailableBonusesForOrder()
      }
    },

    async approvePayManual (payIndex) {
      const query = gqlOrder.APPROVE_PAY_MANUAL
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, payIndex })

      if (response) modals.showMessage({ message: 'Se aprobó el pago correctamente' })
    },

    async declinePayManual (payIndex) {
      const query = gqlOrder.DECLINE_PAY_MANUAL
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, payIndex })

      if (response) modals.showMessage({ message: 'Se declinó el pago correctamente' })
    },

    async checkStatePayU (payIndex, platform) {
      const query = gqlOrder.CHECK_STATE_PAY_U
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, payIndex, platform })

      if (response) modals.showMessage({ message: 'Estado actualizado' })
    },

    async addObservation () {
      const mutation = gqlOrder.ADD_OBSERVATION
      const order = this.dataForm.order

      const response = await gql.mutate(mutation, { order, observation: this.observation.observation, type: this.observation.type })

      if (response) {
        modals.showMessage({ message: `Observación agregada correctamente` })
        this.observation.observation = ''
        this.observation.type = ''
      }
    },
    async newDelivery (order, type) {
      const mutation = gqlOrder.NEW_DELIVERY

      if (!order) return

      const response = await gql.mutate(mutation, { order, type })

      if (response) modals.showMessage({ message: `Se agregó una nueva entrega para la orden ${order}` })
    },

    openStaffRefundModal (sendNotifications = true) {
      const m = this.$refs.staffRefundModal
      if (m && typeof m.open === 'function') m.open({ sendNotifications })
    },

    refreshOrdersAfterStaffRefund () {
      const page = (this.$store.state.data.orders && this.$store.state.data.orders.data && this.$store.state.data.orders.data.page) || 1
      this.$store.commit('getData', { resolver: 'orders', page, key: 'order' })
      this.$store.commit('getData', { resolver: 'changes', page, key: 'change' })
    },

    async newChange () {
      if (this.newChangeData.reasons.length === 1 && this.newChangeData.reasons[0] === '') {
        modals.showMessage({ message: 'Elige por lo menos un motivo por el cual el cliente quiere hacer el cambio', type: 'error' })
        return
      }
      const mutation = gqlChange.NEW
      const order = this.dataOriginal.order
      const response = await gql.mutate(mutation, { order, reasons: this.newChangeData.reasons, waitPackage: this.newChangeData.waitPackage, conveyorPaidByCompany: this.newChangeData.conveyorPaidByCompany })

      if (response) {
        this.newChangeData.reasons = ['']
        modals.showMessage({ message: `Se creó un nuevo cambio para la orden ${order}` })
      }
    },

    async createInvoice () {
      const mutation = gqlInvoice.CREATE
      const order = this.dataOriginal.order
      const response = await gql.mutate(mutation, { order, personType: this.personType, documentType: this.documentType, sendEmail: this.sendEmail })

      if (response && response.data && response.data.createInvoice) {
        modals.showMessage({ message: `Se creó una nueva factura para la orden ${order}` })
      }
    },

    addOrDeleteReason (index) {
      if (this.newChangeData.reasons.length > 0 && this.newChangeData.reasons[index] === '') this.newChangeData.reasons.splice(index, 1)

      const reasonEmptyIndex = this.newChangeData.reasons.findIndex(reason => reason === '')
      if (reasonEmptyIndex === -1) this.newChangeData.reasons.push('')
    },

    async changeMethodPay () {
      if (!this.dataForm.methodPay) {
        modals.showMessage({ message: 'Elige un método de pago', type: 'error' })
        return
      }
      if (this.dataForm.methodPay === this.dataOriginal.methodPay) {
        modals.showMessage({ message: 'No hay cambios en el método de pago', type: 'error' })
        return
      }

      const query = gqlOrder.CHANGE_METHOD_PAY
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, methodPay: this.dataForm.methodPay })

      if (response) {
        modals.showMessage({ message: `Se actualizó el método de pago a ${this.dataForm.methodPay}` })
      }
    },

    async changeUserPayConveyor () {
      if (typeof this.dataForm.userPayConveyor !== 'boolean') {
        modals.showMessage({ message: 'El valor de envío al cobro no es válido', type: 'error' })
        return
      }
      if (this.dataForm.userPayConveyor === this.dataOriginal.userPayConveyor) {
        modals.showMessage({ message: 'No hay cambios en envío al cobro', type: 'error' })
        return
      }

      const mutation = gqlOrder.CHANGE_USER_PAY_CONVEYOR
      const order = this.dataForm.order

      const response = await gql.mutate(mutation, { order, userPayConveyor: this.dataForm.userPayConveyor })

      if (response) {
        modals.showMessage({ message: 'Se actualizó el envío al cobro' })
      }
    },

    async changeIsWholesaler () {
      if (typeof this.dataForm.isWholesaler !== 'boolean') {
        modals.showMessage({ message: 'Elige un tipo de orden (mayorista o unitaria)', type: 'error' })
        return
      }
      if (this.dataForm.isWholesaler === this.dataOriginal.isWholesaler) {
        modals.showMessage({ message: 'No hay cambios en el tipo de orden', type: 'error' })
        return
      }
      const query = gqlOrder.CHANGE_WHOLESALER
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, isWholesaler: this.dataForm.isWholesaler })

      if (response) {
        modals.showMessage({ message: `La orden ${order} se convirtió a ${this.dataForm.isWholesaler ? 'mayorista' : 'unitaria'}` })
      }
    },

    async paidOrder () {
      console.log(this.dataForm.paidWholesaler)
      if (this.dataForm.paidWholesaler !== false && this.dataForm.paidWholesaler !== true) {
        modals.showMessage({ message: 'Elige una opción de pago', type: 'error' })
        return
      }
      const query = gqlOrder.PAID_WHOLESALER
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, paid: this.dataForm.paidWholesaler })

      if (response) {
        modals.showMessage({ message: `${this.dataForm.paidWholesaler ? 'Se pagó la orden' : 'Se eliminó el pago'}` })
      }
    },

    copyUrl (url) {
      this.copyNavigator(url)
      modals.showMessage({ message: `La URL de Addi ha sido copiada` })
    },

    copyWompiOrderId (orderId) {
      this.copyNavigator(String(orderId))
      modals.showMessage({ message: 'ID de transacción Wompi copiado' })
    },

    copyNavigator (text) {
      try {
        this.animationCopy = true
        const type = 'text/plain'
        const blob = new Blob([text], { type })
        const data = [new window.ClipboardItem({ [type]: blob })]
        navigator.clipboard.write(data)
      } catch (error) {
        console.log('Característica sólo soportada en Chrome')
      }
    },
    showSection (section) {
      this.show[section] = !this.show[section]
    },
    async banUser (order) {
      const mutation = gqlOrder.BAN_USER

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se baneó el usuario de la orden ${order} correctamente` })
    },
    async deleteImageReceipt (index) {
      const mutation = gqlOrder.DELETE_IMAGE_RECEIPT
      const order = this.dataForm.order

      const response = await gql.mutate(mutation, { order, index })

      if (response) {
        modals.showMessage({ message: `Se eliminó el comprobante de la orden ${order}` })
        this.$set(this.dataForm.payManual[index], 'receipt', null)
        this.$set(this.dataOriginal.payManual[index], 'receipt', null)
      }
    },
    async handleFileSelect (event, index) {
      const file = event.target.files[0]
      if (!file) return

      if (!file.type.startsWith('image/')) {
        modals.showMessage({ message: 'Por favor selecciona un archivo de imagen', type: 'error' })
        return
      }

      try {
        await this.uploadImageReceipt(index, file)
        event.target.value = ''
      } catch (error) {
        modals.showMessage({ message: 'Error al subir la imagen', type: 'error' })
      }
    },

    async uploadImageReceipt (index, image) {
      const mutation = gqlOrder.UPLOAD_IMAGE_RECEIPT
      const order = this.dataForm.order

      const variables = { image: null, order, index, token: auth.getToken() }

      const formData = new FormData()
      formData.append('operations', JSON.stringify({ query: mutation, variables }))
      formData.append('map', JSON.stringify({ 0: ['variables.image'] }))
      formData.append('0', image, image.name)

      const body = formData

      const response = await gql.mutate(mutation, variables, false, [], body)

      if (!response || !response.data || !response.data.uploadImageReceipt) throw new Error('Error desconocido en el servidor')
      const imageName = response.data.uploadImageReceipt

      this.$set(this.dataForm.payManual[index], 'receipt', imageName)
      this.$set(this.dataOriginal.payManual[index], 'receipt', imageName)
    },

    formatTrackingValue (key, value) {
      if (value === null || value === undefined || value === '') return '-'
      if (typeof value === 'boolean') return value ? 'Sí' : 'No'
      if (key === 'beginSession' || key === 'endSession') return this.dateTime(value)
      return String(value)
    },

    chooseUnpickReturnTier ({ product, size, pickedTier, brand, folder, subfolder, images }) {
      return new Promise((resolve, reject) => {
        this.unpickTierModal = {
          show: true,
          pickedTier,
          item: {
            product,
            size,
            quantity: 1,
            brand: brand || this.dataOriginal.brand,
            folder,
            subfolder,
            image: images && images.length ? images[0] : null
          },
          busy: false,
          resolve,
          reject
        }
      })
    },

    closeUnpickTierModal () {
      if (this.unpickTierModal.busy) return
      if (this.unpickTierModal.reject) this.unpickTierModal.reject(new Error('cancelled'))
      this.unpickTierModal.show = false
      this.unpickTierModal.resolve = null
      this.unpickTierModal.reject = null
    },

    onUnpickTierSelect (returnTier) {
      if (this.unpickTierModal.resolve) this.unpickTierModal.resolve(returnTier)
      this.unpickTierModal.show = false
      this.unpickTierModal.resolve = null
      this.unpickTierModal.reject = null
    },

    chooseChangeSize ({ product, fromSize, brand, folder, subfolder, images, pickedFromTier }) {
      return new Promise((resolve, reject) => {
        this.changeSizeModal = {
          show: true,
          pickedFromTier: pickedFromTier || '',
          item: {
            product,
            fromSize,
            brand: brand || this.dataOriginal.brand,
            folder,
            subfolder,
            image: images && images.length ? images[0] : null
          },
          busy: false,
          resolve,
          reject
        }
      })
    },

    closeChangeSizeModal () {
      if (this.changeSizeModal.busy) return
      if (this.changeSizeModal.reject) this.changeSizeModal.reject(new Error('cancelled'))
      this.changeSizeModal.show = false
      this.changeSizeModal.resolve = null
      this.changeSizeModal.reject = null
    },

    async onChangeSizeConfirm ({ to, returnTier }) {
      const modal = this.changeSizeModal
      if (!modal.item) return

      modal.busy = true

      try {
        const errors = []
        const variables = {
          order: this.dataForm.order,
          product: modal.item.product,
          from: modal.item.fromSize,
          to
        }

        if (returnTier) {
          variables.returnTier = returnTier
        }

        const response = await gql.mutate(
          gqlOrder.REQUEST_SIZE_CHANGE,
          variables,
          false,
          errors
        )

        if (!response || response.error) {
          modals.showMessage({
            message: (response && response.error && response.error.message) || errors[0] || 'No se pudo solicitar el cambio de talla',
            type: 'error'
          })
          return
        }

        const orderData = response.data && response.data.requestOrderSizeChange
        this.applyOrderSizeChangeUpdate(orderData)

        if (orderData && orderData.hasProductChange) {
          this.$store.dispatch('orderNovelty/fetchProductChangeCount')
          modals.showMessage({ message: 'Cambio de talla solicitado correctamente' })
        } else {
          modals.showMessage({ message: 'Talla cambiada correctamente' })
        }

        if (modal.resolve) modal.resolve(orderData)
        modal.show = false
        modal.resolve = null
        modal.reject = null
      } finally {
        modal.busy = false
      }
    },

    applyOrderSizeChangeUpdate (orderData) {
      if (!orderData) return

      if (orderData.cart) {
        this.$set(this.dataForm, 'cart', this.copyObject(orderData.cart))
        this.$set(this.dataOriginal, 'cart', this.copyObject(orderData.cart))
      }

      if (orderData.hasProductChange !== undefined) {
        this.$set(this.dataForm, 'hasProductChange', orderData.hasProductChange)
        this.$set(this.dataOriginal, 'hasProductChange', orderData.hasProductChange)

        if (!orderData.hasProductChange) {
          this.$set(this.dataForm, 'productChange', null)
          this.$set(this.dataOriginal, 'productChange', null)
        }
      }

      if (orderData.productChange !== undefined) {
        const productChange = orderData.productChange ? this.copyObject(orderData.productChange) : null
        this.$set(this.dataForm, 'productChange', productChange)
        this.$set(this.dataOriginal, 'productChange', productChange)
      }

      if (orderData.productChangeHistory !== undefined) {
        const history = this.copyObject(orderData.productChangeHistory || [])
        this.$set(this.dataForm, 'productChangeHistory', history)
        this.$set(this.dataOriginal, 'productChangeHistory', history)
      }
    },

    productChangeActionLabel (action) {
      const labels = {
        requested: 'Solicitado',
        completed: 'Completado',
        rejected: 'Rechazado',
        pending: 'Pendiente'
      }
      return labels[action] || action || '—'
    },

    productChangeReasonLabel (reason) {
      if (!reason) return '—'
      const found = PRODUCT_CHANGE_REJECT_REASONS.find(item => item.key === reason)
      if (found) return found.label
      if (reason === 'cancelled') return 'Cambio cancelado'
      return reason
    },

    productChangeHistoryKey (entry, index) {
      return `${entry.product || ''}-${entry.action || ''}-${entry.from || ''}-${entry.to || ''}-${entry.createdAt || index}`
    },

    async cancelProductChange () {
      if (!this.dataForm.order || !this.pendingProductChange) return

      const errors = []
      const response = await gql.mutate(
        gqlOrder.REJECT_PRODUCT_CHANGE,
        { order: this.dataForm.order, reason: 'cancelled' },
        false,
        errors
      )

      if (!response || response.error) {
        modals.showMessage({
          message: (response && response.error && response.error.message) || errors[0] || 'No se pudo eliminar el cambio',
          type: 'error'
        })
        return
      }

      const orderData = (response.data && response.data.rejectOrderProductChange) || {
        hasProductChange: false,
        productChange: null
      }
      this.applyOrderSizeChangeUpdate({
        hasProductChange: false,
        productChange: null,
        ...orderData
      })
      modals.showMessage({ message: 'Cambio de talla eliminado' })
    }
  },

  computed: {
    isFraudBlocked () {
      return isBlockedByFraud(this.dataForm)
    },

    canPickProducts () {
      return this.dataForm.status === 'paid' && !this.isFraudBlocked
    },

    trackingScalarFields () {
      const tracking = this.dataOriginal.tracking
      if (!tracking) return []

      const fields = [
        ['id', 'ID'],
        ['deviceSessionId', 'Device Session ID'],
        ['ip', 'IP'],
        ['ipReal', 'IP Real'],
        ['country', 'País'],
        ['location', 'Ubicación'],
        ['device', 'Dispositivo'],
        ['operatingSystem', 'Sistema operativo'],
        ['referrer', 'Referrer'],
        ['userAgent', 'User Agent'],
        ['fbp', 'FBP'],
        ['fbc', 'FBC'],
        ['ttp', 'TTP'],
        ['ttclid', 'TTCLID'],
        ['payFacebook', 'Pago Facebook'],
        ['payTiktok', 'Pago TikTok'],
        ['beginSession', 'Inicio sesión'],
        ['endSession', 'Fin sesión'],
        ['isWholesaler', 'Es mayorista'],
        ['openedCart', 'Abrió carrito'],
        ['openedForm', 'Abrió formulario'],
        ['openedFilters', 'Abrió filtros'],
        ['pressPayButton', 'Clic en pagar'],
        ['productsDisplayed', 'Productos mostrados'],
        ['totalProducts', 'Total productos']
      ]

      return fields.map(([key, label]) => ({
        key,
        label,
        value: this.formatTrackingValue(key, tracking[key]),
        multiline: key === 'userAgent' || key === 'referrer'
      }))
    },
    total () {
      return this.dataForm.total || 0
    },

    totalProducts () {
      let total = 0
      for (const product of this.dataForm.cart) {
        total += product.productSubtotal
      }
      return total
    },

    pendingProductChange () {
      if (!this.dataForm.hasProductChange || !this.dataForm.productChange) return null
      return this.dataForm.productChange
    },

    nameHistory () {
      return getDataHistoryByType(this.dataForm, DATA_CHANGE_TYPES.name)
    },

    phoneHistory () {
      return getDataHistoryByType(this.dataForm, DATA_CHANGE_TYPES.phone)
    },

    addressHistory () {
      return getDataHistoryByType(this.dataForm, DATA_CHANGE_TYPES.address)
    },

    emailHistory () {
      return getDataHistoryByType(this.dataForm, DATA_CHANGE_TYPES.email)
    },

    locationHistory () {
      return getLocationHistoryEntries(this.dataForm)
    },

    productChangeHistoryEntries () {
      const history = (this.dataForm.productChangeHistory || []).slice()
      const pending = this.pendingProductChange

      if (pending && pending.from && pending.to) {
        const hasRequested = history.some(entry =>
          entry.action === 'requested' &&
          entry.product === pending.product &&
          entry.from === pending.from &&
          entry.to === pending.to
        )

        if (!hasRequested) {
          history.push({
            action: 'pending',
            product: pending.product,
            from: pending.from,
            to: pending.to,
            createdBy: pending.createdBy,
            createdAt: pending.createdAt
          })
        }
      }

      return history.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    },

    pendingProductChangeItem () {
      const change = this.pendingProductChange
      return change && change.item ? change.item : null
    },

    subtotalDisplay () {
      if (this.dataForm.subtotal != null) return this.dataForm.subtotal
      return this.totalProducts
    },

    discount () {
      return this.dataForm.totalDiscount || 0
    },

    quantity () {
      return this.dataForm.quantity || 0
    },

    conveyors () {
      return this.$store.state.variables.conveyors
    },

    sortedDeliveries () {
      const deliveries = this.dataOriginal.deliveries
      if (!deliveries || !deliveries.length) return []
      return deliveries.slice().sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    },

    methods () {
      return [...this.$store.state.variables.methods, 'cash', 'credit', 'bono']
    },

    /** Métodos disponibles al cambiar pago (sin cash), incluyendo el actual de la orden si fuera cash u otro no listado. */
    methodsForChangePay () {
      const list = this.methods.filter(m => m !== 'cash')
      const mp = this.dataForm.methodPay
      if (mp && !list.includes(mp)) {
        return [mp, ...list]
      }
      return list
    },

    totalPayManual () {
      if (!this.dataForm.payManual || !this.dataForm.payManual.length) return 0
      return this.dataForm.payManual.reduce((total, pay) => {
        if (pay.state === 'approved') total += pay.value
        return total
      }, 0)
    },

    totalPayU () {
      if (!this.dataForm.payU || !this.dataForm.payU.length) return 0
      return this.dataForm.payU.reduce((total, pay) => {
        if (pay.state === 'approved') total += pay.value
        return total
      }, 0)
    },

    bonusesTotal () {
      return this.dataOriginal.bonusesTotal || 0
    },

    buyerDataLocked () {
      return !!(this.dataOriginal && this.dataOriginal.dataLocked)
    },

    isLocationPairModified () {
      if (!this.dataOriginal || !this.dataForm) return false
      return this.dataOriginal.location !== this.dataForm.location ||
        this.dataOriginal.department !== this.dataForm.department
    },

    originalLocationPair () {
      const location = this.dataOriginal.location || ''
      const department = this.dataOriginal.department || ''
      if (!location && !department) return ''
      return department ? `${location} - ${department}` : location
    },

    unlockOrderDataConfirmation () {
      return 'Revisa los datos: ya se generó el remite para esta orden. Debes avisar en bodega antes de modificar la información'
    },

    hasInactiveBonuses () {
      const bonuses = this.dataOriginal.bonusesApplied
      if (!bonuses || !bonuses.length) return false
      return bonuses.some(b => b.status === 'created')
    },

    /** Índice del último bono aplicado (LIFO): solo ese se puede quitar primero desde la UI. */
    bonusRemoveLastIndex () {
      const list = this.dataOriginal.bonusesApplied
      return list && list.length ? list.length - 1 : -1
    },

    pendingBalance () {
      return this.total - this.totalPayManual - this.totalPayU
    },

    legacyStatusHistory () {
      const d = this.dataOriginal
      const entries = []
      const push = (status, createdBy, createdAt) => {
        if (createdBy || createdAt) entries.push({ status, createdBy: createdBy || '', createdAt })
      }
      push('declined', d.declinedBy, d.declinedAt)
      push('approved', d.approvedBy, d.approvedAt)
      push('paid', d.paidBy, d.paidAt)
      push('packed', d.packedBy, d.packedAt)
      push('sent', d.sentBy, d.sentAt)
      if (d.recoveredAt) push('created', d.recoveredBy, d.recoveredAt)
      return entries
    },

    statusHistoryDisplay () {
      const history = this.dataOriginal.statusHistory
      if (history && history.length) return history
      return this.legacyStatusHistory
    },

    text () {
      return this.$store.state.languages.language().order
    },
    quantitySale () {
      return 3
    }
  },

  watch: {
    dataOriginal: {
      handler () {
        if (this.fillData) {
          this.dataForm = this.copyObject(this.dataOriginal)
          if (typeof this.dataForm.userPayConveyor !== 'boolean') {
            this.$set(this.dataForm, 'userPayConveyor', !!this.dataForm.userPayConveyor)
          }
          if (typeof this.dataForm.isWholesaler !== 'boolean') {
            this.$set(this.dataForm, 'isWholesaler', !!this.dataForm.isWholesaler)
          }
          this.resetLocationSearch()
        }
      },
      deep: true
    },

    'show.bonusApplied' (open) {
      if (open) this.loadAvailableBonusesForOrder()
      else {
        this.bonusCodeToAdd = ''
        this.availableBonusesForOrder = []
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.form-order
  position relative
  padding 0em 1rem
  white-space normal !important
  width 100%

.preview-text
  margin 1em 0

.products-order-container
  display flex
  justify-content flex-start
  flex-wrap wrap
  gap 3em 1em
  margin 2em 0
  width 100%

.product-change-pending-list
  margin-top 0

.product-change-pending-wrap
  flex-basis 100%
  box-sizing border-box
  min-width 0
  max-width 100%

  >>> .product-container
    flex-basis 100%
    max-width 100%
    width 100%

.product-change-pending__bar
  display flex
  flex-direction column
  gap .5rem
  margin-top .5rem
  padding 0 .25rem

.product-change-pending__sizes
  font-size .95rem
  font-weight 600

.product-change-pending__actions
  display flex
  flex-wrap wrap
  align-items center
  gap .4rem .5rem

.product-change-pending__link
  display inline-flex
  align-items center
  min-height 2rem
  padding 0 .75rem
  border 1px solid var(--color-border)
  border-radius .35rem
  background var(--background-principal)
  color var(--color-font-principal)
  font-size .9rem
  text-decoration none

  &:active
    opacity .85

@media (min-width: 601px)
  .product-change-pending-wrap
    flex-basis 85%

@media (min-width: 724px)
  .product-change-pending-wrap
    flex-basis 47%

@media (min-width: 1150px)
  .product-change-pending-wrap
    flex-basis 30%

@media (max-width: 768px)
  .product-change-pending__bar
    gap .4rem

  .product-change-pending__sizes
    font-size .9rem

.clone-link
  font-size 1.2em

.payU-pays, .manual-pays
  display flex
  justify-content space-between
  align-items center

.item-bonus
  flex 1
  text-align center
  font-size .85em
  &:first-child
    flex 2
    text-align left
    word-break break-all
  &.bonus-remove
    flex 0 0 2.75rem
    min-width 2.75rem

.bonus-remove-placeholder
  display inline-block
  opacity .45
  cursor help

.bonus-phone-hint
  font-size .85em
  opacity .85
  margin .35em 0 .75em

.add-bonus-row
  margin-bottom 1em

.bonus-link
  color inherit
  text-decoration underline
  cursor pointer
  &:hover
    opacity .7

.buttons-pay-manual
  display inline-flex
  margin .5em 0
  gap 1em

.observation
  display flex
  justify-content space-between

.observation-observation
  flex-basis 40%
  text-align left

.observation-type
  flex-basis 20%

.observation-created-at
  flex-basis 20%

.observation-created-by
  flex-basis 20%
  text-align right

.product-change-product
  flex-basis 14%
  text-align left

.product-change-sizes
  flex-basis 14%

.product-change-action
  flex-basis 12%

.product-change-reason
  flex-basis 20%
  text-align left

.section-title
  display inline-flex
  justify-content space-between
  align-items center
  gap 1em
  text-align center
  width 100%
  cursor pointer

.section-title h3
  font-size 1.2rem
  text-align left
  display inline-flex
  align-items center
  gap .5em

.method-pay-image
  display block
  height 1.5em

.receipt-image
  width 70%

.platform-pay-image
  height 1.3em

.platform-pay-image.epayco
  height 1em

.item-pay-manual.receipt
  display flex
  justify-content flex-start
  align-items flex-start
  flex-direction column
  gap 1em

.item-pay-manual
  flex-basis 14.2%
  width 14.2%
  flex-shrink 0
  text-align left

.item-pay-u
  flex-basis 14.2%
  text-align left

.pay-u-container, .pay-manual
  .list-items
    justify-content flex-start
    align-items flex-start

.pay-u-container
  margin-bottom 2rem

.item-history
  flex-basis 33.333%

.item-delivery
  flex-basis 18%

.delivery-header
  border-radius 0

.item-refund
  flex-basis 15%

.pay-u-container, .pay-manual, .pay-bonuses, .pay-bonuses-issued
  overflow-x scroll
  overflow-y none

.section-title .button-action
  margin-left 1.5em
  position relative
  top -.15em

.button-pay
  margin-bottom 1em

.buttons-product
  display flex
  flex-wrap wrap
  justify-content flex-end
  gap .5em

.form-section.form-order-actions
  flex-direction row
  flex-wrap nowrap
  justify-content flex-start
  align-items center
  gap .5em

.special-section
  margin-left 1em
  margin-bottom 2em

.tracking-section
  margin-top 2em
  margin-bottom 2em

.tracking-scalars
  display grid
  grid-template-columns repeat(auto-fill, minmax(14rem, 1fr))
  gap 1em
  margin-bottom 1.5em

.tracking-array
  margin-bottom 1.5em

  h4
    margin .5em 0

.item-tracking
  flex 1
  text-align center
  font-size .85em
  word-break break-word
  &:first-child
    flex 1.5
    text-align left
  margin-top 2em

.specials-buttons
  display flex
  gap 1em
  justify-content center

.title-pay
  font-weight 600
  display inline-flex
  align-items center
  margin 2em 0
  gap .5em

.item-pay-u-order-id
  font-size 1rem

.item-pay-u-platform-user
  display flex
  align-items center
  gap 0.5em
  text-transform capitalize
  font-size 1rem
  font-weight 600
  justify-content flex-start

.item-pay-manual.gap-column
  align-items flex-start
  justify-content flex-start

.locations
  display inline-flex
  flex-wrap wrap
  gap 1em
  margin 1em 0

.location-option-selected .button-action
  border-color var(--color-font-principal)

.no-found
  margin 1em 0
  padding 0 1.5em

.location-confirmed:not(.location-locked)
  cursor pointer

  .input,
  .label
    pointer-events none

.location-label-original
  text-transform none

.choose-location-text
  color var(--color-red)
  margin 1.5rem 0
</style>



// WEBPACK FOOTER //
// src/components/pages/order/Form.vue